import { useState } from 'react';
import { getParcelData } from '@/services';

export const useParcelData = () => {
  const [parcelData, setParcelData] = useState<{ recipientName: string; recipientPhone: string } | null>(null);

  const fetchParcelData = async (phone: string) => {
    try {
      const data = await getParcelData(phone);
      setParcelData(data);
    } catch (error) {
      console.error('Error fetching parcel data:', error);
      throw error;
    }
  };

  return { parcelData, fetchParcelData };
};